const webDate = {
  industryCategory: [
    '批發、零售、傳直銷業',
    '文教相關業',
    '大眾傳播相關業',
    '旅遊、休閒、運動業',
    '一般服務業',
    '電子資訊、軟體、半導體相關業',
    '一般製造業',
    '農林漁牧水電資源業',
    '運輸物流及倉儲',
    '政治宗教及社福相關業',
    '金融投顧及保險業',
    '法律、會計、顧問、研發、設計業',
    '建築營造及不動產相關業',
    '醫療保健及環境衛生業',
    '礦業及土石採取業',
    '住宿、餐飲服務業',
  ],
  jobCategory: [
    '經營、人資類', '行政、總務、法務類',
    '財會、金融專業類', '行銷、企劃、專案管理類',
    '客服、門市、業務、貿易類',
    '餐飲、旅遊、美容美髮類',
    '資訊軟體系統類',
    '操作、技術、維修類',
    '資材、物流、運輸類',
    '營建、製圖類',
    '傳播藝術、設計類',
    '文字、傳媒類',
    '醫療、保健服務類',
    '學術、教育、輔導類',
    '研發類',
    '生產製造、品管、環衛類',
    '軍警消、保全類',
    '其他類',
  ],
  city: [
    '基隆市',
    '台北市',
    '新北市',
    '桃園市',
    '新竹縣',
    '新竹市',
    '苗栗縣',
    '台中市',
    '彰化市',
    '南投縣',
    '雲林縣',
    '嘉義縣',
    '台南市',
    '台南市',
    '屏東縣',
    '宜蘭縣',
  ],
  education: ['不限', '高中職', '大學', '碩士', '博士'],
  candidateEducation: ['國中小', '高中職', '大學', '碩士', '博士'],
  workExp: ['不限', '一年以下', '1~3年', '3~5年', '5年以上'],
  candidateWorkExp: ['無工作經驗', '一年以下', '1~3年', '3~5年', '5年以上'],
  workTime: ['日班', '夜班', '假日班'],
  workType: ['全職', '兼職', '實習'],
};
export default webDate;
